import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress } from '@material-ui/core';
import moment from 'moment';
import React, { useCallback, useState } from 'react';
import { FormattedNumber } from 'react-intl';
import { toast } from 'react-toastify';
import { useObservable, useCallbackObservable } from 'react-use-observable';
import { of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import refundService from 'v2/services/requestManagement/refund';

import useStyle from './styles';

export default function ApproveMotive() {
  const classes = useStyle();
  const [open] = useObservable(() => refundService.getApprove(), []);
  const [currentRefund] = useObservable(() => refundService.getCurrentRefund(), []);
  const [isSubmitting, setSubmitting] = useState<boolean>(false);

  const close = useCallback(() => {
    refundService.closeApprove();
  }, []);

  const [onSubmit] = useCallbackObservable(() => {
    setSubmitting(true);
    return refundService.approve(currentRefund).pipe(
      tap(() => {
        setSubmitting(false);
        refundService.closeApprove();
        toast.success('Solicitação aprovada com sucesso!');
      }),
      catchError((err) => {
        setSubmitting(false);
        toast.error(err);
        return of(true);
      })
    );
  }, [currentRefund]);

  return (
    <Dialog aria-labelledby='customized-dialog-title' open={open} maxWidth={'sm'}>
      <DialogTitle id='customized-dialog-title'>
        <div className={classes.dialogTitle}>Aprovar Reembolso</div>
      </DialogTitle>
      <DialogContent dividers>
        {open && (
          <>
            <span>Dados da Solicitação de Reembolso</span>
            <p>
              <b> Fatura: </b> {currentRefund.invoice_id}
            </p>
            <p>
              <b> Valor: </b> <FormattedNumber value={currentRefund.invoice_value} format='BRL' />
            </p>
            <p>
              <b> Comprador: </b> {currentRefund.buyer_name}
            </p>
            <p>
              <b> Data de pagamento: </b> {moment(currentRefund.invoice_payment_date).format('DD/MM/YYYY')}
            </p>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={close} disabled={isSubmitting}>
          Cancelar
        </Button>
        <Button variant='contained' color='secondary' type='submit' disabled={isSubmitting} onClick={onSubmit}>
          Aprovar Reembolso
          {isSubmitting && <CircularProgress size={15} style={{ color: '#192542', marginLeft: 10 }} />}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
